"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllergenLevel = void 0;
var AllergenLevel = /** @class */ (function () {
    function AllergenLevel() {
    }
    AllergenLevel.contains = "CONTAINS";
    AllergenLevel.mayContain = "MAY_CONTAIN";
    AllergenLevel.freeFrom = "FREE_FROM";
    return AllergenLevel;
}());
exports.AllergenLevel = AllergenLevel;
